import React from "react";
import $ from "jquery";
import {BotonAddPequeño, BotonDown, BotonMenosPequeño, BotonRemovePequeño, BotonPesar} from "../Plantillas/Botones";
import { formatSoles, TIPO_STOCK } from "../../Global";
import _ from "lodash";
import MagellanListener, { KILOGRAMO_UNIT_DESCRIPTION } from "../../helpers/MagellanListener";
import '../styles/DetalleProductoGrifo.css';

export default class DetallesProductoGrifos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cantidadInput: 1,
            verPrecios: true,
            magellanListenerIsAvailable: false,
            isEditing: false,
        }
        this.verificarPrecioCosto = this.verificarPrecioCosto.bind(this);
        this.queryParams = new URLSearchParams(window.location.search)
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        let divCarrito = $("#tableDetProdGrifos");
        let rows = $("#IdDetProductoCarritoGrifos").find('tr');

        if (rows.length >= 6)
            divCarrito.scrollTop(divCarrito.prop('scrollHeight'))
    }

    async verificarPrecioCosto() {
        try {
            const responseVal =await fetch(`/api/prices/precioCosto/validar`);
            const data = await responseVal.json();
            this.setState({verPrecios: true})
        } catch (e) {
            this.setState({verPrecios: false})
        }
    }
    async componentDidMount() {
        this.setState({
            isEditing: window.location.href.includes("/edit/")
        })

        MagellanListener.addSubscriber(this);
        this.setState({ magellanListenerIsAvailable: MagellanListener.sourceIsRunning() });
        await this.verificarPrecioCosto()
    }
    requestWeight(detalle) {
        const add = this.props.detalles.some(p => p.IdProducto === detalle.IdProducto);
        MagellanListener.requestWeight(detalle.IdProducto, add);
    }
    onRecieveWeight(weight, owner, addWeight) {
        const detalle = this.props.detalles.find(p => p.IdProducto === owner);

        if (!detalle) {
            return;
        }

        this.props.InputCantidadDetalleChange({
            target: {
                value: addWeight ? (detalle.Cantidad + weight) - 1 : weight
            }
        }, detalle);
    }
    onMagellanChangeAvailability(availability) {
        this.setState({ magellanListenerIsAvailable: availability });
    }


    render() {
        let canUpdatePrice = !_.isUndefined(this.props.canUpdatePrice) ? this.props.canUpdatePrice : true;
        let canIncrementProductPrice = !!this.props.incrementarPrecioProd ? this.props.incrementarPrecioProd : false;
        
        return (
            <div id="tableDetProdGrifos" className="grifos__carrito mt-2">
                <div className="grifos__tabla-container">
                    <table className="table table-sm table-hover grifos__tabla">
                        <thead className="grifos__cabecera">
                            <tr>
                                <th className="grifos__th-producto">Producto</th>
                                <th className="grifos__th-cantidad text-center">Cant.</th>
                                <th className="grifos__th-precio text-center">Precio</th>
                                <th className="grifos__th-total text-center">Total</th>
                                <th className="grifos__th-acciones text-center"></th>
                            </tr>
                        </thead>
                        <tbody id="IdDetProductoCarritoGrifos">
                        {
                            this.props.detalles.map((det, i) => {
                                return (
                                    <tr
                                        id={`producto-grifo-${det.IdPresentacion}`}
                                        key={`det-grifo-${det.IdPresentacion}`}
                                        className={`grifos__fila ${det.IdTipoStock === TIPO_STOCK.CON_COMPROBANTE ? "" : "grifos__fila--sin-comprobante"}`}
                                        onKeyUp={(e) => this.props.onSecretKeyPress(e, det)}
                                    >
                                        {/* Columna Producto */}
                                        <td className="grifos__td-producto">
                                            <div className="grifos__producto-info">
                                                <div className="grifos__producto-nombre">
                                                    <span className="grifos__nombre-normal">
                                                        {det.descripcion} {det.unidadMedida}
                                                    </span>
                                                    {/* {String(det.EsFacturable) === "1" ? (
                                                        <span className="grifos__nombre-normal">
                                                            {det.descripcion} {det.unidadMedida}
                                                        </span>
                                                    ) : (
                                                        <span className="grifos__nombre-especial">
                                                            {det.descripcion} {det.unidadMedida}
                                                        </span>
                                                    )} */}
                                                </div>
                                                
                                                {/* Opciones de precio y costo */}
                                                {/* {!this.state.isEditing && (
                                                    <div className="grifos__opciones-precio">
                                                        {this.props.venderConListaPrecios === 1 && (
                                                            <select
                                                                required
                                                                disabled={this.props.load}
                                                                className="grifos__select-precio"
                                                                value={det.Precio}
                                                                onChange={(e) => this.props.PrecioChange(e, det)}
                                                            >
                                                                <option value={det.PrecioMenor}>Menor/Lista</option>
                                                                <option value={det.PrecioFamiliar}>Familiar</option>
                                                                <option value={det.PrecioEspecial}>Especial</option>
                                                            </select>
                                                        )}
                                                        
                                                        {this.state.verPrecios && (
                                                            <div className="grifos__precio-costo">
                                                                <small>
                                                                    Costo: S/ {det.PrecioVenta.toLocaleString("en-GB", {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                    })}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </div>
                                                )} */}
                                            </div>
                                        </td>

                                        {/* Columna Cantidad */}
                                        <td className="grifos__td-cantidad text-center">
                                                <input
                                                    onClick={(e) => e.target.select()}
                                                    readOnly={true}
                                                    type="number"
                                                    className="abed__grifos__input grifos__input--cantidad grifos__input--readonly"
                                                    step="1"
                                                    min="1"
                                                    name="Cantidad"
                                                    disabled={true}
                                                    value={det.Cantidad}
                                                    onChange={e => this.props.InputCantidadDetalleChange(e, det)}
                                                    onBlur={e => this.props.onBlurInputCantidad(e, det)}
                                                />
                                        </td>

                                        {/* Columna Precio */}
                                        <td className="grifos__td-precio text-center">
                                            <input
                                                onClick={(e) => e.target.select()}
                                                readOnly={true}
                                                type="number"
                                                className="abed__grifos__input grifos__input--precio grifos__input--readonly"
                                                step="0.01"
                                                min="0"
                                                disabled={true}
                                                value={det.PrecioVenta}
                                                name="PrecioVenta"
                                            />
                                        </td>

                                        {/* Columna Total */}
                                        <td className="grifos__td-total text-center">
                                            <input 
                                                type="number"
                                                readOnly={true}
                                                disabled={true}
                                                onChange={e => this.props.onChangeTotal(e, det)}
                                                onBlur={e => this.props.onBlurTotal(e, det)}
                                                onClick={e => e.target.select()}
                                                className="abed__grifos__input grifos__input--total grifos__input--readonly"
                                                value={formatSoles(det.Total - (det.Total * formatSoles(this.props.descuentoPorCliente)))}
                                            />
                                        </td>

                                        {/* Columna Acciones */}
                                        <td className="grifos__td-acciones text-center">
                                            {this.queryParams.get('disabled') !== 'true' && (
                                                <div className="grifos__acciones-container">
                                                    {/* {(this.state.magellanListenerIsAvailable && 'unidadMedida' in det && det.unidadMedida === KILOGRAMO_UNIT_DESCRIPTION) ? (
                                                        <BotonPesar 
                                                            disabled={this.props.load}
                                                            className="grifos__boton grifos__boton--pesar"
                                                            type="button"
                                                            title="Pesar"
                                                            onClick={() => this.requestWeight(det)}
                                                        />
                                                    ) : (
                                                        <div className="grifos__botones-cantidad">
                                                            <BotonMenosPequeño
                                                                disabled={this.props.load}
                                                                className="grifos__boton grifos__boton--menos"
                                                                type="button"
                                                                title="Disminuir en 1"
                                                                onClick={() => this.props.RestarCantidadDet(det)}
                                                            />
                                                            <BotonAddPequeño
                                                                disabled={this.props.load}
                                                                className="grifos__boton grifos__boton--mas"
                                                                type="button"
                                                                title="Aumentar en 1"
                                                                onClick={(e) => {
                                                                    e.stopPropagation()
                                                                    this.props.AgregarCantidadDet(det)
                                                                }}
                                                            />
                                                        </div>
                                                    )} */}
                                                    
                                                    {/* <div className="grifos__botones-acciones">
                                                        <BotonRemovePequeño
                                                            disabled={this.props.load}
                                                            className="grifos__boton grifos__boton--eliminar"
                                                            type="button"
                                                            title="Quitar item"
                                                            onClick={() => this.props.RemoveProductoInList(det)}
                                                        />
                                                        <BotonDown
                                                            disabled={this.props.load}
                                                            className="grifos__boton grifos__boton--descuento"
                                                            onClick={() => this.props.handleOpenModalDescuento(det)}
                                                            title="Descuento"
                                                        />
                                                    </div> */}
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </div>

                {/* Mostrar mensaje cuando no hay productos */}
                {this.props.detalles.length === 0 && (
                    <div className="grifos__mensaje-vacio">
                        <div className="grifos__mensaje-contenido">
                            <h3><i className="fas fa-gas-pump grifos__icono-vacio"></i> No hay productos seleccionados</h3>
                        </div>
                    </div>
                )}
            </div>
        );   
    
    }


}